import axios from 'axios';
import { optnAPI } from '@api/modules/optn';

/**
 * 根据id获取数据中心数据(通用)
 * @param {number} id perm_id
 * @param {string} column 字段名，默认为'param1'
 * @param {string} type 返回类型，默认为'no'，可选值为'no'|'select'
 * @param {string} otherColumn 额外字段
 * @param repalceApi
 */
export const getDataCenterByPermId = async ({ id, column = 'param1', type = 'no', otherColumn = '', repalceApi }) => {
  let res = await axios.get(repalceApi ? repalceApi : optnAPI.getOptnByPermId, { params: { perm_id: id } });
  if (res.data.code === 0) {
    const optnCnttList = res.data.data.form.optn_cntt_list;
    switch (type) {
      case 'no':
        return optnCnttList;
      case 'select':
        return optnCnttList.map(item => ({
          value: item[column],
          label: item[column],
          ...(otherColumn && { [otherColumn]: item[otherColumn] })
        }));
      case 'valueList':
        let valueList = {};
        optnCnttList.forEach(item => {
          valueList[item[column]] = { value: item[column], label: item[column] };
        });
        return valueList;
      case 'valueListAndDefault':
        let valueListObj = {};
        let valueListArr = [];
        optnCnttList.forEach(item => {
          let temp = { value: item[column], label: item[column], ...(otherColumn && { [otherColumn]: item[otherColumn] }) };
          valueListObj[item[column]] = temp;
          valueListArr.push(temp);
        });
        return [valueListObj, valueListArr];
    }
  } else return [];
};

/**
 * 设置表单中开始和结束时间的值，根据需要转换时间单位。
 * @param {Object} searchForm - 目标表单对象。
 * @param {string} startTimeKey - 开始时间的键名。
 * @param {string} endTimeKey - 结束时间的键名。
 * @param {Array<number>} [dateRange=[]] - 日期范围数组，包含两个元素[开始时间, 结束时间]。
 * @param {boolean} [convertToSeconds=true] - 是否将毫秒转换为秒。
 */
export const setTime = (searchForm, startTimeKey, endTimeKey, dateRange = [], convertToSeconds = true) => {
  const [startTime, endTime] = dateRange || [];
  // 确保时间戳被正确赋值且进行单位转换（如果需要）
  searchForm[startTimeKey] = startTime ? Math.floor(convertToSeconds ? startTime / 1000 : startTime) : null;
  searchForm[endTimeKey] = endTime ? Math.floor(convertToSeconds ? endTime / 1000 : endTime) : null;
};